// extracted by mini-css-extract-plugin
module.exports = {"PreviousButtonIcon":"PreviousButtonIcon-3v7QT","CarouselButton":"CarouselButton-29InI"};